import { createApiWithNewBasePath as api } from '../../../api';
import { ICompanyInfoForm, ICompanyInfoResponse, IMessageResponse } from '../types';

export const getCompanyInformation = async (id: number): Promise<ICompanyInfoResponse> => {
  const response = await api.get(`/pros/${id}`);
  return response.data as ICompanyInfoResponse;
};

export const saveCompanyInformation = async ({ id, ...companyInformation }: { id?: number } & ICompanyInfoForm): Promise<ICompanyInfoResponse> => {
  const clientProId = id ? `/${id}` : '';
  const response = await api[id ? 'put' : 'post'](
    `/pros${clientProId}`,
    {
      pro: {
        owner_type: 'client',
        ...companyInformation
      }
    }
  );
  return response.data as ICompanyInfoResponse;
};

export const deleteCompanyInformation = async (id: number): Promise<IMessageResponse> => {
  const response = await api.delete(`/pros/${id}`);
  return response.data as IMessageResponse;
};

export const destroyProIntent = async (): Promise<IMessageResponse> => {
  const response = await api.delete("/pro/destroy_intent");
  return response.data as IMessageResponse;
};
